import { render, staticRenderFns } from "./ListForward.vue?vue&type=template&id=2d2ccdff&scoped=true&lang=html&"
import script from "./ListForward.vue?vue&type=script&lang=js&"
export * from "./ListForward.vue?vue&type=script&lang=js&"
import style0 from "./ListForward.vue?vue&type=style&index=0&id=2d2ccdff&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ccdff",
  null
  
)

export default component.exports